import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { ConfigBlock } from 'components/molecules/settings/styled';
import { InputDescription, InputTitle } from 'components/atoms/styleds';
import RadioButtons from 'components/atoms/RadioButtons';
import NumberInput from 'components/atoms/NumberInput';
import Input from 'components/atoms/Input';
import InfoTooltip from 'components/atoms/InfoTooltip';
import Select from 'components/atoms/Select';
import { Divider } from 'components/atoms/styleds';
import { getErrorByKey } from 'utils';

import { CreateLink } from 'components/molecules/user/Menu/styled';

import { useServiceForm } from 'hooks/formStates/settings';
import WeekTimes from './WeekTimes';
import RoomChangeItem from './RoomChangeItem';
import { Wrapper } from './styled';

const averageDurations = [
  {
    id: '30_minutes',
    title: '30 minuti',
  },
  {
    id: '45_minutes',
    title: '45 minuti',
  },
  {
    id: '60_minutes',
    title: '1 h',
  },
  {
    id: '90_minutes',
    title: '1.5 h',
  },
  {
    id: '120_minutes',
    title: '2 h',
  },
  {
    id: '150_minutes',
    title: '2.5 h',
  },
  {
    id: '180_minutes',
    title: '3 h',
  },
];

const ServiceForm = ({
  localState,
  onSelectTime,
  onChange,
  onClickChip,
  onClickAddRoom,
  errors,
  isEditMode,
  onChangeRoom,
  rooms,
}) => {
  const [localVal, setLocalVal] = useState(
    // localState.confirmation_type === 'none' ? 'none' : false,
    localState.auto_confirmation,
  );
  const radioItems = [
    {
      value: true,
      label: 'Dispongo di un’unica sala',
    },
    {
      value: false,
      label: 'Dispongo di più sale',
    },
  ];

  useEffect(() => {
    setLocalVal(
      // localState.confirmation_type === 'none' ? 'none' : false,
      localState.auto_confirmation,
    );
  }, [localState]);

  const showConfirmationStatuses = localState.confirmation_type !== 'none';

  const autoAcceptRadioItems = [
    {
      value: true,
      label: 'Sì',
      // relationView: showConfirmationStatuses && (
      //   <>
      //     <InputDescription>
      //       Accetto <strong>automaticamente</strong> le prenotazioni online:<InfoTooltip />
      //
      //     </InputDescription>
      //     <Select
      //       name='confirmation_type'
      //       label='Scegli tra le opzioni proposte'
      //       defaultLabel='Dall’inizio del servizio'
      //       selectedKey={localState.confirmation_type}
      //       items={[
      //         {
      //           id: 'until_hour',
      //           title: 'Fino all\'ora dell\'ultimo arrivo',
      //         },
      //         {
      //           id: 'until_start',
      //           title: 'Dall\'inizio del servizio',
      //         },
      //         {
      //           id: 'until_half',
      //           title: 'Fino a 30 min prima dell\'inizio del servizio',
      //         },
      //       ]}
      //       onChange={onChange}
      //     />
      //   </>
      // ),
    },
    {
      // value: 'none',
      value: false,
      label: 'No, desidero poterle rifiutare',
    },
  ];

  const timeSlotsRadioItems = [
    {
      value: '30_minutes',
      label: '30 minuti',
    },
    {
      value: '15_minutes',
      label: '15 minuti',
    },
  ];

  const onChangeLocalConfirmationType = useCallback(
    (e) => {
      const {
        target: { value },
      } = e;
      // setLocalVal(value === 'none' ? 'none' : false);
      // if (value === 'none') {
      //   return onChange({
      //     // target: { name: 'confirmation_type', value: 'none' },
      //     target: { name: 'auto_confirmation', value: true },
      //   });
      // }
      // onChange({ target: { name: 'confirmation_type', value: 'until_hour' } });
      onChange({ target: { name: 'auto_confirmation', value: value === 'true' } });
    },
    [onChange],
  );

  const selectedRooms = useMemo(() => {
    return localState?.services_rooms_attributes?.filter(i => !!i.room_id || !!i.room);
  }, [localState?.services_rooms_attributes]);

  const filteredRooms = useMemo(() => {
    return rooms.filter(room => !selectedRooms?.find(sRoom =>
      // (+sRoom.room_id === room.id) || (sRoom.room && sRoom.room.id === room.id)
      (sRoom.room && !sRoom.room_id) ? sRoom.room.id === room.id : +sRoom.room_id === room.id
    ));
  }, [selectedRooms, rooms]);

  const getRoomsList = (item) => {
    const result = [...filteredRooms];
    const selectedItem = rooms.find(r =>
      // r.id === (+item.room_id) || (item.room && item.room.id === r.id)
      (item.room && !item.room_id) ? item.room.id === r.id : r.id === +item.room_id
    );
    if (selectedItem) {
      result.push(selectedItem);
    }
    return result;
  };

  const allowAddNewRoom = rooms?.length - selectedRooms?.length>= 1;

  return (
    <Wrapper>
      <ConfigBlock showBorder={true} desktop_pb={60}>
        <InputTitle>1. Nome del servizio</InputTitle>
        <InputDescription>
          Scrivi il nome che identifica il servizio.
        </InputDescription>
        <Input
          name='title'
          label='Nome del servizio'
          placeholder='Es: Pranzo 1° turno'
          value={localState.title}
          onChange={onChange}
          error={getErrorByKey(errors, 'title')}
        />
        <InputDescription>Indica il numero totale di coperti.</InputDescription>
        <Input
          type='number'
          name='total_seats'
          label='Totale coperti'
          placeholder='Es: 30'
          value={localState.total_seats}
          onChange={onChange}
          error={getErrorByKey(errors, 'total_seats')}
        />
        <InputDescription>
          Indica la durata media della permanenza dei clienti.
        </InputDescription>
        <Select
          onChange={onChange}
          name='service_duration'
          selectedKey={localState.service_duration}
          label='Durata media del servizio'
          items={averageDurations}
          error={getErrorByKey(errors, 'service_duration')}
        />
        <InputDescription>
          Indica il costo di prenotazione a persona per questo servizio (facoltativo).
        </InputDescription>
        <Input
          type='text'
          name='price'
          label='Costo di prenotazione a persona'
          placeholder='Es: 3,00€'
          value={localState.price}
          onChange={onChange}
          error={getErrorByKey(errors, 'price')}
        />
        <InputDescription>
          Indica il numero massimo di persone per prenotazione/tavolo per questo servizio.
        </InputDescription>
        <Input
          type='number'
          name='booking_max_person_count'
          label='Numero massimo di persone per tavolo'
          placeholder='Es: 6'
          value={localState.booking_max_person_count}
          onChange={onChange}
          error={getErrorByKey(errors, 'booking_max_person_count')}
        />
        <InputDescription>
          Seleziona i giorni e gli orari in cui è disponibile il servizio.
        </InputDescription>
        <WeekTimes
          data={localState}
          onSelectTime={onSelectTime}
          onClickChip={onClickChip}
          errors={errors}
          isEditMode={isEditMode}
        />
      </ConfigBlock>
      <ConfigBlock showBorder={true}>
        <InputTitle>2. Scelta della sala</InputTitle>
        <InputDescription>
          Associa il servizio a una o più sale.
        </InputDescription>
        {localState?.services_rooms_attributes?.map((i, index) => (
          <>
            <RoomChangeItem
              key={i.id || index.toString()}
              onChange={onChangeRoom}
              item={i}
              rooms={getRoomsList(i)}
              // rooms={rooms}
              errors={errors}
            />
            <Divider />
          </>
        ))}
        <CreateLink
          role='presentation'
          disabled={!allowAddNewRoom}
          as='span'
          onClick={allowAddNewRoom ? onClickAddRoom : undefined}
        >
          + Aggiungi sala
        </CreateLink>
      </ConfigBlock>
      <ConfigBlock showBorder={false}>
        <InputTitle>3. Gestione prenotazioni</InputTitle>
        <InputDescription>
          Permetti la prenotazione online fino a:
        </InputDescription>
        <Select
          name='prereservation_time'
          label='Scegli tra le opzioni proposte'
          defaultLabel='opzioni proposte'
          selectedKey={localState.prereservation_time}
          items={[
            {
              id: 'none',
              title: 'All\'arrivo degli ospiti',
            },
            {
              id: '15_minutes',
              title: '15 min prima dell\'arrivo degli ospiti',
            },
            {
              id: '30_minutes',
              title: '30 min prima dell\'arrivo degli ospiti',
            },
            {
              id: '60_minutes',
              title: '60 min prima dell\'arrivo degli ospiti',
            },
            {
              id: '120_minutes',
              title: '120 min prima dell\'arrivo degli ospiti',
            },
            {
              id: '180_minutes',
              title: '180 min prima dell\'arrivo degli ospiti',
            },
          ]}
          onChange={onChange}
          error={getErrorByKey(errors, 'prereservation_time')}
        />
        <Divider mb={20} mobileMb={20} />
        <InputTitle>
          4. Accetti automaticamente le prenotazioni online ?
        </InputTitle>
        <RadioButtons
          items={autoAcceptRadioItems}
          onChange={onChangeLocalConfirmationType}
          selected={localVal}
        />
        <Divider mb={20} mobileMb={20} />
        <InputTitle>
          5. Gestisci le prenotazioni con le fasce orarie da:
        </InputTitle>
        <RadioButtons
          items={timeSlotsRadioItems}
          name='slot_duration'
          onChange={onChange}
          selected={localState.slot_duration}
        />
        <InputTitle mb={20} >
          6. Indica la disponibilità massima di coperti per fascia oraria.
        </InputTitle>
        <Input
          type='number'
          name='slot_seats'
          label='Coperti per fascia oraria'
          placeholder='Es: 6'
          value={localState.slot_seats}
          onChange={onChange}
          error={getErrorByKey(errors, 'slot_seats')}
        />
      </ConfigBlock>
    </Wrapper>
  );
};

export default ServiceForm;
